// eslint-disable-next-line jira/restricted/react-18
import { startTransition, useEffect, useState, useSyncExternalStore } from 'react';
import { functionWithCondition } from '@atlassian/jira-feature-flagging-utils';
import { fg } from '@atlassian/jira-feature-gating';

export const useIsClientReadyOld = (): boolean => {
	const [ready, setReady] = useState(false);

	useEffect(() => {
		startTransition(() => setReady(true));
	}, []);

	return ready;
};

/**
 * True if we're rendering on the client and hydration has completed (or we aren't hydrating).
 * Always false on the server.
 * @see https://tkdodo.eu/blog/avoiding-hydration-mismatches-with-use-sync-external-store
 */
export const useIsClientReadyNew = (): boolean =>
	useSyncExternalStore(
		() => () => {
			// empty
		},
		() => true,
		() => false,
	);

export const useIsClientReady = functionWithCondition(
	() => fg('jfp-magma-4013-fix-hydration-edition-awareness'),
	useIsClientReadyNew,
	useIsClientReadyOld,
);
